import { Checkbox, CircularProgress, List, ListItem, ListItemButton, Paper, Stack, Typography } from '@mui/material';
import { AmazonMarketplaceOption } from '@domain/connection/models/AmazonMatchPreview';
import SetupSection from '@features/connections/setup/SetupSection';
import iso3166 from 'iso-3166-1';

interface StoresStepProps {
  marketplaces: AmazonMarketplaceOption[];
  loading: boolean;
  onToggle: (id: string) => void;
}

const StoresStep = ({ marketplaces, loading, onToggle }: StoresStepProps) => (
  <SetupSection title="Connect stores" description="Select every store you want to connect to JustStock.">
    {loading ? <CircularProgress size={24} /> : (
      <Paper variant="outlined">
        <List disablePadding>
          {marketplaces.map((marketplace) => (
            <ListItem key={marketplace.id} disablePadding divider>
              <ListItemButton onClick={() => onToggle(marketplace.id)} sx={{ p: 2 }}>
                <Checkbox checked={marketplace.selected} />
                <Stack direction="row" spacing={1}>
                  <Typography >{iso3166.whereAlpha2(marketplace.countryCode ?? '')?.country}</Typography>
                  <Typography color="text.secondary">{marketplace.name}</Typography>
                </Stack>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    )}
  </SetupSection>
);

export default StoresStep;
